export default "__VITE_ASSET__BbEw2tTE__"